
















































import FormBase from '@/pages/form-base';
import axios from 'axios'
import {Component} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import User from '@/models/User'
import Event, {IEvent} from '@/models/Event'
import BasicForm from '@/components/entry/BasicForm.vue'
import AuthLayout from '@/components/auth/Layout.vue'
import {apiV1EventPath, apiV1UsersPath} from '@/rails/routes'
import EventCard from "@/components/events/Card.vue"

@Component({
  components: {
    AuthLayout,
    BasicForm,
    EventCard
  }
})
export default class SignUpIndex extends VueBase {
  user = new User()
  agree = false
  errors = {}
  event = new Event()

  async mounted(): Promise<void> {
    this.user.referer = (document.getElementById('referer') as HTMLInputElement).value
    if (this.queryParam('message')) {
      this.showMessage(this.queryParam('message'))
    }
    if (this.queryParam('event_id')) {
      try {
        const res = await axios.get<IEvent>(apiV1EventPath(this.queryParam('event_id')))
        this.event = new Event(res.data)
      } catch {
      }
    }
  }

  get signInUrl(): string {
    const url = '/users/sign_in'
    const params = new URLSearchParams(window.location.search).toString()
    return params ? `${url}?${params}` : url
  }

  async save(): Promise<void> {
    if (!(this.$refs.basicForm as FormBase).validate()) {
      this.showError('入力内容に不備があります。確認してください。')
      return
    }

    try {
      const res = await axios.post<string>(apiV1UsersPath(), {
        user: this.user.toParamsSignUp(),
        event_id: new URLSearchParams(window.location.search).get('event_id')
      })
      // イベントの申込完了画面など、必要に応じて別タブで開く
      if (res.data) {
        window.open(res.data, '_blank')
      }
      // GA対応のためユーザー完了画面へ遷移する。
      window.location.href = '/users/complete'
    } catch (e) {
      console.log(e)
      this.showError('入力内容に不備があります。確認してください。')
      this.errors = JSON.parse(e.request.response)
    }
  }
}
